module.exports = __webpack_public_path__ + "static/feather-2-1e42d00439fe83a8a63b6d35cc43ee52.png";